import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import forEach from "lodash/forEach";
import get from "lodash/get";
import includes from "lodash/includes";
import { Flex, Box, Button } from "ui-components";
import FormattedMessage from "components/FormattedMessage";
import TotalPrice from "components/TotalPrice";
import Label from "components/FormFields/Label";
import TextField from "components/FormFields/TextField";
import { iconThemes } from "ui-components/theme";
import Alert from "react-s-alert";
import { normalizerTypes } from "normalizers";

const submitHiddenPaymentForm = data => {
  const { request_url, form_data } = data || {};
  if (!isEmpty(request_url) && !isEmpty(form_data)) {
    // create an invisible form to make a post request to wirecard
    const form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", request_url);

    forEach(form_data, (value, key) => {
      const hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", value);
      form.appendChild(hiddenField);
    });

    document.body.appendChild(form);
    form.submit();
  }
};

const WirecardForm = ({ paymentRequest, appSettings, locale, formValues }) => {
  const cardPrefix = get(formValues, "cardPrefix", "");
  const prefixLength = get(
    appSettings,
    "generic.ipp_allowed_card_prefix_length",
    6
  );
  const allowedCardPrefixes = get(
    appSettings,
    "generic.ipp_allowed_card_prefixes",
    []
  );
  const errorMessage = get(
    locale,
    "card_not_supported_error",
    "Card Not Supported"
  );
  const showStatus = cardPrefix.length === prefixLength;
  const cardPrefixValid = showStatus
    ? includes(allowedCardPrefixes, Number(cardPrefix))
    : false;
  const themeColor = iconThemes.blue;
  const submitForm = () => {
    cardPrefixValid && submitHiddenPaymentForm(paymentRequest);
  };

  useEffect(() => {
    if (showStatus && !cardPrefixValid) {
      Alert.error(errorMessage);
    }
  }, [showStatus, cardPrefixValid, errorMessage]);

  return (
    <Box
      variant="borderSection"
      mb={8}
      padding={[0, 0]}
      sx={{
        color: themeColor,
        borderColor: themeColor,
        width: "100%",
        maxWidth: "568px"
      }}
    >
      <TotalPrice title={"card_eligibility_check"} bgColor={themeColor} />
      <Flex mb={2} px={2} flexDirection="column" alignItems="center">
        <Label
          sx={{ color: iconThemes.black }}
          label={
            <FormattedMessage id={"enter_first_digits_of_ipp_supported_card"} />
          }
          required={true}
        />
        <Flex justifyContent="space-evenly" px={"1rem"} maxWidth={"10rem"}>
          <TextField
            required
            type="number"
            field="cardPrefix"
            inlineValidation={showStatus ? { valid: cardPrefixValid } : {}}
            normalize={normalizerTypes.NUMBER_WITH_MAX_LENGTH({
              max_length: prefixLength
            })}
            inputStyle={{
              fontSize: "1.4rem",
              padding: "0.3rem",
              paddingRight: "1.3rem",
              textAlign: showStatus ? "left" : "center"
            }}
          />
        </Flex>
        <Button
          disabled={!cardPrefixValid}
          width="fit-content"
          onClick={submitForm}
        >
          <FormattedMessage id="confirm" />
        </Button>
      </Flex>
    </Box>
  );
};

export default WirecardForm;
